import CustomSpan from '../../../../../components/CustomSpan';
import { TableDetailsRow } from '../../../../../components/CustomTable/types/table.type';
import { EnumOption } from '../../../../../modules/types/types';

interface StatusRenameInfo {
  label: string;
  backgroundColor: string;
}

const getStatusRenameInfo = (
  statusRenameNumber: number | undefined,
  theme: any,
): StatusRenameInfo => {
  switch (statusRenameNumber) {
    case 1:
      return { label: 'Não publicado', backgroundColor: theme.colors.amarelo };
    case 2:
      return { label: 'Publicado', backgroundColor: theme.colors.verde };
    case 3:
      return { label: 'Ampliação de uso', backgroundColor: theme.colors.azul };
    case 4:
      return { label: 'Excluído', backgroundColor: theme.colors.vermelho };
    default:
      return { label: 'Não informado', backgroundColor: theme.colors.cinza };
  }
};

export const buildOffCanvasData = (
  data: any[],
  theme: any,
  {
    getTipoProdutoInfo,
    umidadeProduto,
    acondicionamentoProduto,
    grupoFinanciamento,
  }: {
    getTipoProdutoInfo: (item: any) => React.ReactNode;
    umidadeProduto?: EnumOption[];
    acondicionamentoProduto?: EnumOption[];
    grupoFinanciamento?: EnumOption[];
  },
): TableDetailsRow[] => {
  return data.map((item) => {
    const tipoProdutoInfo = getTipoProdutoInfo(item);
    const { label, backgroundColor } = getStatusRenameInfo(
      item.statusRename,
      theme,
    );

    const renderSimNao = (valor?: string) => (
      <CustomSpan texto={valor === 'S' ? 'Sim' : 'Não'} />
    );

    return {
      id: item?.id ?? 'Não informado',
      produto: <b>{item?.produtoFarmaceutico ?? 'Não informado'}</b>,
      tipoProduto: tipoProdutoInfo,
      codigoAtc: item.codigoAtc,

      umidade: umidadeProduto?.[item.umidade]?.label ?? 'Não informado',

      acondicionamento:
        acondicionamentoProduto?.[item.acondicionamento]?.label ??
        'Não informado',

      oncologico: renderSimNao(item?.oncologico),
      biologico: renderSimNao(item?.biologico),
      rara: renderSimNao(item?.doencaRara),

      status:
        item?.statusDistribuicao === 'S' ? (
          <CustomSpan texto="Ativo" />
        ) : (
          <CustomSpan texto="Inativo" />
        ),

      statusRename: (
        <div style={{ textAlign: 'left' }}>
          <span
            style={{
              backgroundColor,
              borderRadius: '5px',
              padding: '5px 10px',
              color: 'white',
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {label}
          </span>
        </div>
      ),

      compBasico: renderSimNao(item?.compBasico),
      compEspecializado: renderSimNao(item?.compEspecializado),

      grupoEspecializado:
        grupoFinanciamento?.[item.especializadoGrupo]?.label ?? 'Não se aplica',

      compEstrategico: renderSimNao(item?.compEstrategico),
      usoHospitalar: renderSimNao(item?.usoHospitalar),
      farmaciaPopular: renderSimNao(item?.farmaciaPopular),

      tags: item?.tags || 'Não informado',
      observacoes: item?.observacoes || 'Não informado',
    };
  });
};
